import { defineStore } from 'pinia'
import { ButtonStates, ButtonState } from '@/types'
import typedStore from '@/store/typedStore'

export interface IBuilderState {
  buttonState: ButtonState
  lastUsedSidepanel: string | undefined
}

export const useBuilderStore = defineStore({
  id: 'builder',
  state: (): IBuilderState => ({
    buttonState: ButtonStates.ICON,
    lastUsedSidepanel: undefined,
  }),

  actions: {
    async save ({ saveSuccess, saveFail, imageUploadRequired }: {
      saveSuccess: () => void,
      saveFail: () => void,
      imageUploadRequired: () => void,
    }) {
      this.buttonState = ButtonStates.PROCESSING

      const saveNodeDeletionsResponse = await typedStore.primary.entities.nodes.saveNodeDeletions()
      if (saveNodeDeletionsResponse === 'failure') {
        saveFail()
        this.buttonState = ButtonStates.FAILURE
        return false
      }

      const saveNewNodesResponse = await typedStore.primary.entities.nodes.saveNewNodes()
      if (saveNewNodesResponse === 'failure') {
        saveFail()
        this.buttonState = ButtonStates.FAILURE
        return false
      }

      if (typedStore.primary.entities.images.imagesNeedUpload) {
        imageUploadRequired()
        this.buttonState = ButtonStates.ICON
        return false
      }

      const saveNodeUpdatesResponse = await typedStore.primary.entities.nodes.saveNodeUpdates()
      if (saveNodeUpdatesResponse === 'failure') {
        saveFail()
        this.buttonState = ButtonStates.FAILURE
        return false
      }

      const saveConfigResponse = await typedStore.primary.app.saveConfig()
      if (saveConfigResponse === 'failure') {
        saveFail()
        this.buttonState = ButtonStates.FAILURE
        return false
      } else {
        saveSuccess()
        this.buttonState = ButtonStates.SUCCESS
        setTimeout(() => {
          this.buttonState = ButtonStates.ICON
        }, 3000)
        return true
      }
    },

    setLastUsedSidepanel (sidepanel: string) {
      this.lastUsedSidepanel = sidepanel
    },
  },
})
